import { graphql } from '@eluve/graphql.tada';

export const appointmentLlmOutputFragment = graphql(`
  fragment AppointmentLlmOutput on AppointmentLlmOutputs @_unmask {
    __typename
    appointmentId
    llmOutputId
    output {
      __typename
      id
      content
      status
      failureType
      completedAt
      metadata {
        __typename
        llmOutputId
        prompt_template {
          outputType
        }
      }
    }
  }
`);

export const getLatestAppointmentLlmOutputByOutputTypeQuery = graphql(
  `
    query getLatestAppointmentOutputByOutputType(
      $tenantId: uuid!
      $appointmentId: uuid!
      $outputType: LlmOutputTypesEnum!
    ) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        __typename
        id
        appointment_llm_outputs(
          where: {
            output: {
              metadata: {
                prompt_template: { outputType: { _eq: $outputType } }
              }
              completedAt: { _isNull: false }
            }
          }
          orderBy: { output: { completedAt: DESC } }
          limit: 1
        ) {
          ...AppointmentLlmOutput
        }
      }
    }
  `,
  [appointmentLlmOutputFragment],
);

export const listenForAppointmentLlmOutputsSubscription = graphql(`
  subscription AppointmentLlmOutputsSubscription(
    $tenantId: uuid!
    $appointmentId: uuid!
    $outputType: LlmOutputTypesEnum!
    $initialValue: timestamptz!
  ) {
    appointmentLlmJobsStream(
      where: {
        tenantId: { _eq: $tenantId }
        appointmentId: { _eq: $appointmentId }
        llmOutputType: { _eq: $outputType }
        jobStatus: { _eq: COMPLETED }
      }
      batchSize: 1
      cursor: { initialValue: { updatedAt: $initialValue }, ordering: ASC }
    ) {
      __typename
      appointmentId
      jobId
    }
  }
`);

export const listenForAppointmentLlmOutputStatusSubscription = graphql(`
  subscription AppointmentLlmOutputStatusSubscription(
    $tenantId: uuid!
    $appointmentId: uuid!
    $outputType: LlmOutputTypesEnum!
  ) {
    appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
      __typename
      id
      appointment_llm_jobs(
        where: { llmOutputType: { _eq: $outputType } }
        orderBy: { createdAt: DESC }
        limit: 1
      ) {
        __typename
        jobStatus
      }
    }
  }
`);

export const getAllAppointmentLlmOutputByOutputTypeQuery = graphql(
  `
    query getAllAppointmentLlmOutputByOutputType(
      $tenantId: uuid!
      $appointmentId: uuid!
      $outputType: LlmOutputTypesEnum!
    ) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        __typename
        id
        appointment_llm_outputs(
          where: {
            output: {
              metadata: {
                prompt_template: { outputType: { _eq: $outputType } }
              }
              completedAt: { _isNull: false }
            }
          }
          orderBy: { output: { completedAt: DESC } }
        ) {
          ...AppointmentLlmOutput
        }
      }
    }
  `,
  [appointmentLlmOutputFragment],
);
